  /**
 * 资源中心分组
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'
  
  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
   export const AddResourceCenter = (data) => {
    return post('/api/app/ResourceCenter', data, {});
   }
   
   /**
   * 批量新增数据记录
   * @param {*} data
   * @returns
   */
   export const AddResourceCenters = (data) => {
    return post('/api/app/resourceCenter/resourceCenters', data, {});
   }

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
    export const ModifyResourceCenter = (data) => {
        return put('/api/app/ResourceCenter', data, {});
    }

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
    export const DeleteResourceCenter = (id) => {
        return del('/api/app/ResourceCenter/' + id, {}, {});
    }
/**
 * 根据id查询
 * @param {*} data
 * @returns
 */
    export const SelectResourceCenterByCode = (code) => {
        return get('/api/app/resourceCenter?id=' + code);
    }
    /**
 * 分页获取数据
 * @param {*} data
 * @returns
 */
    export const GetDataResourceCenterList = (data) => {
        return post('/api/app/resourceCenter/list', data, {});
    }

    //重命名
    export const RenameResourceCenter = (id,name) => {
        return put(`/api/app/resourceCenter/${id}/resourceName?rename=${name}`,null, {});
    }

   /**
   * 批量删除
   * @param {*} data
   * @returns
   */
    export const DelResources = (data) => {
        return post('/api/app/resourceCenter/DelResources', data, {});
    }

    /**
   * 批量更新
   * @param {*} data
   * @returns
   */
     export const UpdResources = (data) => {
        return post('/api/app/resourceCenter/UpdResources', data, {});
    }